'use client'
import { GeneralInformation } from '@/payload-types'
import { useHeaderTheme } from '@/providers/HeaderTheme'
import { usePathname } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import { HeaderNav } from './HeaderNav'
import { MobileNav } from './MobileNav'
import { cn } from '@/utilities/ui'
import { HttpTypes } from '@medusajs/types'
import { quicksand } from '@/utilities/fontImport'

type HeaderClientProps = GeneralInformation & {
  customer: HttpTypes.StoreCustomer | null
}

export const HeaderClient: React.FC<HeaderClientProps> = ({ customer, ...props }) => {
  /* Storing the value in a useState to avoid hydration errors */
  const [theme, setTheme] = useState<string | null>(null)
  const { headerTheme, setHeaderTheme } = useHeaderTheme()
  const pathname = usePathname()

  useEffect(() => {
    setHeaderTheme(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  useEffect(() => {
    if (headerTheme && headerTheme !== theme) setTheme(headerTheme)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerTheme])

  return (
    <header className={cn('relative z-999 font-bold', quicksand.className)}>
      <HeaderNav data={props} customer={customer} />
      <MobileNav {...props} customer={customer} />
    </header>
  )
}
